import React from 'react';
import { Button } from 'react-bootstrap5';

import useW9FormLink from 'components/Common/Billing/Hooks/useW9FormLink';

export default function ButtonW9Form() {
  const { loading: loadingW9FormLink, w9FormLink } = useW9FormLink();

  const downloadW9Form = () => {
    if (w9FormLink) {
      window.open(w9FormLink, '_blank', 'noreferrer');
    }
  };

  return (

    <Button
      variant="outline-primary"
      className="btn-reverse"
      disabled={loadingW9FormLink}
      onClick={downloadW9Form}
    >
      Download W-9 Form
    </Button>

  );
}
